module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "DummyLevel",
	"sourceName": "contracts/levels/DummyLevel.sol",
	"abi": [
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "renounceOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address payable",
					"name": "_instance",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/DummyLevel.sol/DummyLevel.json
// module id = 1551
// module chunks = 0